import { TrackingEventName } from '@/models/analytics/eventTypes';
import {
  trackAccountCreatedSpec,
  trackAccountDeletedSpec,
  trackApplicationInstallSpec,
  trackAuthFallbackUsedSpec,
  trackAuthManualLinkCopiedSpec,
  trackAuthManualOpenClickedSpec,
  trackAuthenticationClickedSpec,
  trackComplianceCheckSpec,
  trackTokenGeneratedSpec,
  trackUserClickedSpec,
  trackUserSignedInSpec,
  trackUserSignedOutSpec,
  trackUserSignedUpSpec,
  trackUserStartedSpec,
  trackUserUpdatedSpec,
  type AccountCreated,
  type AccountDeleted,
  type ApplicationInstall,
  type AuthFallbackUsed,
  type AuthManualLinkCopied,
  type AuthManualOpenClicked,
  type AuthenticationClicked,
  type ComplianceCheck,
  type TokenGenerated,
  type UserClicked,
  type UserSignedIn,
  type UserSignedOut,
  type UserSignedUp,
  type UserStarted,
  type UserUpdated,
} from '@snowtype/snowplow';
import type { SnowplowEventMap } from '../trackSnowplowEvent';

export const userEvents: SnowplowEventMap = {
  [TrackingEventName.UserSignedUp]: (props) =>
    trackUserSignedUpSpec(props as UserSignedUp),
  [TrackingEventName.AccountCreated]: (props) =>
    trackAccountCreatedSpec(props as AccountCreated),
  [TrackingEventName.AccountDeleted]: (props) =>
    trackAccountDeletedSpec(props as AccountDeleted),
  [TrackingEventName.AuthenticationClicked]: (props) =>
    trackAuthenticationClickedSpec(props as AuthenticationClicked),
  [TrackingEventName.UserClicked]: (props) => trackUserClickedSpec(props as UserClicked),
  [TrackingEventName.UserSignedIn]: (props) =>
    trackUserSignedInSpec(props as UserSignedIn),
  [TrackingEventName.UserSignedOut]: (props) =>
    trackUserSignedOutSpec(props as UserSignedOut),
  [TrackingEventName.UserStarted]: (props) => trackUserStartedSpec(props as UserStarted),
  [TrackingEventName.UserUpdated]: (props) => trackUserUpdatedSpec(props as UserUpdated),
  [TrackingEventName.ComplianceCheck]: (props) =>
    trackComplianceCheckSpec(props as ComplianceCheck),
  [TrackingEventName.AuthFallbackUsed]: (props) =>
    trackAuthFallbackUsedSpec(props as AuthFallbackUsed),
  [TrackingEventName.AuthManualLinkCopied]: (props) =>
    trackAuthManualLinkCopiedSpec(props as AuthManualLinkCopied),
  [TrackingEventName.AuthManualOpenClicked]: (props) =>
    trackAuthManualOpenClickedSpec(props as AuthManualOpenClicked),
  [TrackingEventName.TokenGenerated]: (props) =>
    trackTokenGeneratedSpec(props as TokenGenerated),
  [TrackingEventName.ApplicationInstalled]: (props) =>
    trackApplicationInstallSpec(props as ApplicationInstall),
};
